;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('SliderController', sliderController)

  /* @ngInject */
  function sliderController ($scope, $attrs) {
    $scope.open = {
      proprieties: {},
      duration: 0,
      callback: undefined
    }

    $scope.close = {
      proprieties: {},
      duration: 0,
      callback: undefined
    }

    $scope.sliderOpen = false
    $scope.animationDone = true
    $scope.scrollActive = true

    $scope.openButtons = []
    $scope.closeButtons = []

    $scope.slider = $attrs.$$element
    $scope.slider.addClass($scope.sliderClass)
    // $scope.slider.hide()

    $scope.setOpenSettings = function (proprieties, duration, callback) {
      $scope.open = {
        proprieties: proprieties,
        duration: !isNaN(duration) || 0,
        callback: callback || function () {}
      }
    }

    $scope.setCloseSettings = function (proprieties, duration, callback) {
      $scope.close = {
        proprieties: proprieties,
        duration: !isNaN(duration) || 0,
        callback: callback || function () {}
      }
    }

    $scope.closeIfClickOutside = false

    $scope.setSliderOpen = function (state) {
      if ($scope.animationDone) {
        if (state && !$scope.sliderOpen) {
          $scope.animationDone = false
          $scope.slider.show()
          $scope.slider.scrollTop(0)
          $scope.slider.animate($scope.open.proprieties, {
            easing: 'swing',
            duration: $scope.open.duration,
            complete: () => {
              $scope.animationDone = true
              $scope.sliderOpen = true
              if ($scope.open.callback) { $scope.open.callback() }
            }
          })
        } else

        if (!state) {
          $scope.animationDone = false
          $scope.slider.animate($scope.close.proprieties, {
            easing: 'swing',
            duration: $scope.close.duration,
            complete: () => {
              $scope.slider.hide()
              $scope.animationDone = true
              $scope.sliderOpen = false
              if ($scope.close.callback) { $scope.close.callback() }
            }
          })
        }
      }
    }

    $scope.handleClickOutside = function () {
      if (!$scope.closeIfClickedOutside) {
        $scope.closeIfClickedOutside = true

        $scope.closeActivator = $('<div class="slider-close-activator"></div>')
        $scope.closeActivator.css('left', $scope.slider.outerWidth() + 'px')
        $scope.closeActivator.css('width', 'calc( 100vw - ' + $scope.slider.outerWidth() + 'px)')

        $scope.slider.append($scope.closeActivator)

        $scope.closeActivator.click(function () {
          $scope.setSliderOpen(false)
        })
      }
    }
  }
})()
